import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientPortalState } from "../../redux";

export interface IInvoiceSlice {
    showDialog?: boolean;
    invoiceStripePayment?: IInvoiceStripePayment;
}

export interface IInvoiceStripePayment {
    idempotencyKey: string;
    practitionerStripeAccountId: string;
    practitionerId: number;
    invoiceIds: number[];
    totalAmount?: number;
    amount: number;
    fee?: number;
}

const initialBookingState: IInvoiceSlice = {
    showDialog: false,
    invoiceStripePayment: undefined,
};

export const invoiceSlice = createSlice({
    name: "invoice",
    initialState: initialBookingState,
    reducers: {
        openInvoicePayStripeDialog(state, action: PayloadAction<Omit<IInvoiceStripePayment, "idempotencyKey">>) {
            state.showDialog = true;
            state.invoiceStripePayment = {
                ...action.payload,
                idempotencyKey: crypto.randomUUID(),
                totalAmount: action.payload.amount + (action.payload.fee || 0),
            };
        },
        closeInvoicePayStripeDialog(state) {
            state.showDialog = false;
            state.invoiceStripePayment = undefined;
        },
    },
});

export const { openInvoicePayStripeDialog, closeInvoicePayStripeDialog } = invoiceSlice.actions;

export const selectInvoice = (state: ClientPortalState) => state.invoice;

export default invoiceSlice.reducer;
